import React from 'react';
import CustomDashboard from '../pages/Dashboard/CustomDashboard';


const Dashboard = () => {
   

    return (
       <CustomDashboard/>
    );
};

export default Dashboard;
